import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/no-array-index-key */
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { OV_EMS_CDN, OV_IMG_SERVICE_URL, OV_S3_BUCKET } from '../../config/theme';
import { jsx as _jsx } from "react/jsx-runtime";
var DEFAULT_SRC = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

var cdnUrl = function cdnUrl(_ref) {
  var crop = _ref.crop,
      src = _ref.src,
      size = _ref.size,
      width = _ref.width;
  var WEBP = window.OV.WEBP;
  var wdth = Math.round(Math.min(size, width));
  var edits = {
    resize: {
      fit: crop ? 'cover' : 'inside',
      height: crop ? wdth : 10000,
      width: wdth
    }
  };

  if (WEBP) {
    edits.toFormat = 'webp';
  }

  var request = JSON.stringify({
    bucket: OV_S3_BUCKET,
    key: src.split(OV_EMS_CDN).join(''),
    edits: edits
  });
  return "".concat(OV_IMG_SERVICE_URL).concat(btoa(request));
};

var Image = function Image(props) {
  var alt = props.alt,
      className = props.className,
      crop = props.crop,
      height = props.height,
      lazyload = props.lazyload,
      sizes = props.sizes,
      src = props.src,
      width = props.width;

  if (!src) {
    return false;
  }

  var imgSrc = lazyload ? DEFAULT_SRC : src;
  var imgProps = {
    alt: alt,
    className: cc([className, 'lazyload']),
    src: imgSrc
  };

  if (height && width) {
    imgProps['style'] = {
      aspectRatio: "".concat(width, " / ").concat(height)
    };
  }

  if (!src.startsWith(OV_EMS_CDN)) {
    // eslint-disable-next-line jsx-a11y/alt-text
    return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({}, imgProps), {}, {
      "data-src": src
    }));
  }

  var threshold = 1200;
  var ratio = window.devicePixelRatio >= 2 ? 0.75 : 1;
  var srcset = {};
  var srcProps = {
    crop: crop,
    src: src,
    size: width > threshold ? width * ratio : width,
    width: width
  };
  srcset[width] = "".concat(cdnUrl(srcProps), " ").concat(width, "w");
  sizes.forEach(function (size) {
    var key = size;

    if (key * ratio <= width) {
      srcset[key] = "".concat(cdnUrl(_objectSpread(_objectSpread({}, srcProps), {}, {
        size: key > threshold ? key * ratio : key
      })), " ").concat(key, "w");
    }

    key = Math.round(size * 1.5);

    if (key * ratio <= width) {
      srcset[key] = "".concat(cdnUrl(_objectSpread(_objectSpread({}, srcProps), {}, {
        size: key > threshold ? key * ratio : key
      })), " ").concat(key, "w");
    }

    key = size * 2;

    if (key * ratio <= width) {
      srcset[key] = "".concat(cdnUrl(_objectSpread(_objectSpread({}, srcProps), {}, {
        size: key > threshold ? key * ratio : key
      })), " ").concat(key, "w");
    }
  });
  imgProps['data-sizes'] = 'auto';
  imgProps[lazyload ? 'data-srcset' : 'srcSet'] = Object.values(srcset).join(','); // eslint-disable-next-line jsx-a11y/alt-text

  return /*#__PURE__*/_jsx("img", _objectSpread({
    "data-original-src": src
  }, imgProps));
};

Image.defaultProps = {
  className: '',
  crop: false,
  height: false,
  lazyload: true,
  sizes: [300, 600, 900],
  width: 900
};
Image.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  crop: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  lazyload: PropTypes.bool,
  sizes: PropTypes.arrayOf(PropTypes.number),
  src: PropTypes.string.isRequired,
  width: PropTypes.number
};
export default /*#__PURE__*/memo(Image);